import { Button, EButtonColorVariant } from '@outdoorsyco/bonfire';
import Image from 'next/image';
import React from 'react';
import { useIntl } from 'react-intl';

import RentYourRV2XImage from '@/assets/blog/rent-your-rv/rent-your-rv@2x.jpg';
import AspectRatio from '@/components/common/AspectRatio';
import Heading from '@/components/switchback/Heading/Heading';

export const RentYourRV: React.FC = () => {
  const intl = useIntl();
  return (
    <>
      <div className="mb-12 gap-6 lg:items-center grid grid-cols-1 lg:gap-16 lg:grid-cols-2">
        <div className="lg:row-span-1 lg:col-span-1">
          <AspectRatio ratio="1.4:1" hasImageHover>
            <Image
              src={RentYourRV2XImage}
              alt="Rent your RV"
              quality={65}
              layout="fill"
              objectFit="cover"
              objectPosition="bottom"
            />
          </AspectRatio>
        </div>

        <div className="mx-4 lg:mx-0 lg:row-span-1 lg:col-span-1">
          <Heading level={2} className="highlight autoType800">
            {intl.formatMessage({ defaultMessage: 'Earn $36,000 per year or more.', id: 'zJKGLG' })}
          </Heading>
          <p className="mt-3">
            {intl.formatMessage({
              defaultMessage:
                'Make adventure your business. Outdoorsy owners can make up to $36,000 per year for each RV listed on our peer-to-peer marketplace. How much could you earn?',
              id: 'DH67br',
            })}
          </p>
          <Button
            href="/list-your-rv"
            className="inline-block mt-4"
            variant={EButtonColorVariant.Primary}
            label={intl.formatMessage({ defaultMessage: 'Get started', id: '/aBLH2' })}
            fullWidth
          />
        </div>
      </div>
    </>
  );
};
